import {Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {FieldSettingsModel} from "@syncfusion/ej2-dropdowns";
import {CheckBoxSelectionService, MultiSelectComponent, MultiSelectModule} from "@syncfusion/ej2-angular-dropdowns";

import {TYPE} from "../../types/types";

@Component({
    selector: 'app-form-multi-select',
    imports: [
        ReactiveFormsModule,
        MultiSelectModule
    ],
    templateUrl: './form-multi-select.component.html',
    styleUrl: './form-multi-select.component.scss',
    providers: [CheckBoxSelectionService]
})
export class FormMultiSelectComponent implements OnInit, OnChanges {
  @ViewChild('multiselect') public multiselect: MultiSelectComponent | undefined;

  @Input() public fCN: string = '';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() public dataSource: any[] = [];
  @Input() public mapping: FieldSettingsModel = {text: 'name', value: 'id'};
  @Input() public disabled: boolean = false;
  @Input() public cssClass: string = '';
  @Input() public fG: FormGroup = new FormGroup({});
  @Input() public placeholder: string = '';
  @Input() public showSelectAll: boolean = true;
  @Input() public selectAllText: string = '';
  @Input() public unSelectAllText: string = '';
  @Input() public mode: "Default" | "Delimiter" | "Box" | "CheckBox" = "Default";
  @Input() public errorText: string = '';
  @Input() public hasErrorField: boolean = false;
  @Output() public  valueChange: EventEmitter<string | number | TYPE.FieldSettingsModelWithId> = new EventEmitter<string | number | TYPE.FieldSettingsModelWithId>();

  public ngOnInit(): void {
    // Disable the dropdown if needed
    if (this.disabled) {
      this.fG.controls[this.fCN].disable();
    }
  }

  public ngOnChanges(): void {
    setTimeout(() => {
      this.multiselect?.refresh();
    }, 5);
  }
}
